import React, { forwardRef } from 'react';

import { useClassName } from 'common/hooks';

import './center.less';

const Center = forwardRef(function Center({ children, className, style }, ref) {
  const classNames = useClassName('CLPCenter');

  return (
    <div
      className={`${classNames('container')} ${className}`}
      style={style}
      ref={ref}>
      {children}
    </div>
  );
});

export default Center;
